import { Application, MBS2MRHelper, MBSAccessHelper, Module, Privilege } from '@fides/fides-react-components';
import { User } from '../../../../core/models';

export const addAndEditPageAccessGranted = (accessHelper: MBSAccessHelper, user: User): boolean => {
  const userHasAdminOrEditPermission =
    accessHelper.hasPermissionForModule(Module.USER, Privilege.ADMIN) ||
    accessHelper.hasPermissionForModule(Module.USER, Privilege.EDIT);

  const clientLvlImpersonation = accessHelper.isImpersonatedAsClient && accessHelper.isAnyFidesAdmin();
  const userLvlImpersonation = user.impersonatedUser && accessHelper.isAnyFidesAdmin() && userHasAdminOrEditPermission;

  return (
    (userHasAdminOrEditPermission && !user.impersonated) ||
    (accessHelper.isFidesAdministratorUM(Application.EFTWEB) && !user.impersonatedUser) ||
    clientLvlImpersonation ||
    userLvlImpersonation
  );
};

export const userHasAccessToAllActions = (accessHelper: MBSAccessHelper, user: User): boolean => {
  const userHasAdminOrEditPermission =
    accessHelper.hasPermissionForModule(Module.USER, Privilege.ADMIN) ||
    accessHelper.hasPermissionForModule(Module.USER, Privilege.EDIT);

  const clientLvlImpersonation =
    accessHelper.isImpersonatedAsClient && accessHelper.isFidesAdministratorUM(Application.EFTWEB);

  const userLvlImpersonation =
    user.impersonatedUser && accessHelper.isFidesAdministratorUM(Application.EFTWEB) && userHasAdminOrEditPermission;

  return (
    (userHasAdminOrEditPermission && !user.impersonated) ||
    accessHelper.isFidesAdministratorUM(Application.EFTWEB) ||
    clientLvlImpersonation ||
    userLvlImpersonation
  );
};

export const TwoMREnabledForUser = (twoMRHelper: MBS2MRHelper): boolean =>
  twoMRHelper.is2MREnabled && twoMRHelper.is2MREnabledFor(Module.USER);
